import React from 'react';
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Utils
import { isSomeOf } from 'utils/common';

// Components
import { FamilyMembersList } from '../FamilyMembersList';
import { ServiceTermsFamily } from '../ServiceTermsFamily';
import { ManageInviteNumber } from '../ManageInviteNumber';

const ComponentsRouter = () => {
  const { invites } = useSelector((state) => state.family);
  const { path } = useRouteMatch();
  const termsPath = `${path}/terms`;

  const invitePaths = invites.map((invite) => invite.ctn);

  return (
    <Switch>
      <Route
        path={path}
        exact
        render={() => {
          if (!invites?.length) {
            return <Redirect to={termsPath} />;
          }
          return <FamilyMembersList />;
        }}
      />
      <Route
        path={termsPath}
        component={ServiceTermsFamily}
      />
      <Route
        path={`${path}/:id`}
        render={({ match: { params: { id } } }) => {
          if (isSomeOf(invitePaths, id)) {
            return <ManageInviteNumber id={id} />;
          }
          return <Redirect to={termsPath} />;
        }}
      />
      <Redirect to={path} />
    </Switch>
  );
};

export { ComponentsRouter };
